<div class="table-scroll">
 <div>
    <!-- <button style="margin-bottom: 10px;margin-left: -12px" mat-button title="Add New Transform" [matMenuTriggerFor]="menu">
        <mat-icon>add</mat-icon>
        <span >Add Transform</span>
    </button> -->

    <button style="color: rgb(247, 246, 240)" mat-button     class="add-transform-btn" title="Add New Transform" [matMenuTriggerFor]="menu" style="margin-bottom: 10px;margin-left: -13px;margin-top: 3px;">
        <mat-icon class="white-icon" style="margin-right: 10px;margin-left: 15px;">add</mat-icon>
       Add Transform
      </button>
    <mat-menu #menu="matMenu" yPosition="below">
        <button mat-menu-item (click)="addTransformer(TransformerType.activityNamer)" [disabled]="!restrictTransformers(TransformerType.activityNamer)" 
        style="display: flex; align-items: center; gap: 8px;"> 
            <!-- <mat-icon>mediation</mat-icon> -->
            <img 
        [src]="getTransformerIcon(TransformerType.activityNamer)" 
        alt="icon" 
        style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Activity Namer</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.anonymizer)"  [disabled]="!restrictTransformers(TransformerType.anonymizer)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>event_note</mat-icon> -->
            <img 
        [src]="getTransformerIcon(TransformerType.anonymizer)" 
        alt="icon" 
      style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Anonymizer</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.columnCalc)" [disabled]="!restrictTransformers(TransformerType.columnCalc)"  style="display: flex; align-items: center; gap: 8px;"> 
            <!-- <mat-icon>event_note</mat-icon> -->
                <img 
        [src]="getTransformerIcon(TransformerType.columnCalc)" 
        alt="icon" 
        style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Column Calc</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.columnCleaner)" [disabled]="!restrictTransformers(TransformerType.columnCleaner)"  style="display: flex; align-items: center; gap: 8px;"> 
            <!-- <mat-icon>event_note</mat-icon> -->
                <img 
        [src]="getTransformerIcon(TransformerType.columnCleaner)" 
        alt="icon" 
        style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Column Cleaner</span>
        </button>
        <button mat-menu-item (click)="addTransformerColumnLookUp(TransformerType.columnLookup)"  [disabled]="!restrictTransformers(TransformerType.columnLookup)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>event_note</mat-icon> -->
               <img 
        [src]="getTransformerIcon(TransformerType.columnLookup)" 
        alt="icon" 
       style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Column Lookup</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.eventGroupNamer)"  [disabled]="!restrictTransformers(TransformerType.eventGroupNamer)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>event_note</mat-icon> -->
              <img 
        [src]="getTransformerIcon(TransformerType.eventGroupNamer)" 
        alt="icon" 
        style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Event Group Namer</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.eventNamer)"  [disabled]="!restrictTransformers(TransformerType.eventNamer)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>event_note</mat-icon> -->
             <img 
        [src]="getTransformerIcon(TransformerType.eventNamer)" 
        alt="icon" 
       style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Event Namer</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.groupAttributor)"  [disabled]="!restrictTransformers(TransformerType.groupAttributor)"  style="display: flex; align-items: center; gap: 8px;">
              <img 
        [src]="getTransformerIcon(TransformerType.groupAttributor)" 
        alt="icon" 
       style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Group Attributor</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.rowExtractor)"  [disabled]="!restrictTransformers(TransformerType.rowExtractor)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>auto_fix_high</mat-icon> -->
                <img 
        [src]="getTransformerIcon(TransformerType.rowExtractor)" 
        alt="icon" 
        style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Row Extractor</span>
        </button>
        <button mat-menu-item (click)="addTransformer(TransformerType.rowFiller)"  [disabled]="!restrictTransformers(TransformerType.rowFiller)"  style="display: flex; align-items: center; gap: 8px;">
            <!-- <mat-icon>event_note</mat-icon> -->
               <img 
        [src]="getTransformerIcon(TransformerType.rowFiller)" 
        alt="icon" 
       style="width: 24px; height: 24px; margin-right: 8px;">
            <span>Row Filler</span>
        </button>
        <!-- <button mat-menu-item (click)="addTransformer(TransformerType.columnCalc)">  [disabled]="!restrictTransformers(TransformerType.columnCalc)">
            <mat-icon>event_note</mat-icon>
            <span>Column Calculator</span>
        </button> -->
    </mat-menu>
</div>

<h1 *ngIf="dataSource.data.length === 0" class="center" style="color: lightgray">No Transforms</h1>
<div style="margin-left: -6px;">
<mat-table style="margin-left: 4px;"
    cdkDropList 
    #table 
    *ngIf="dataSource.data.length > 0"
    (cdkDropListDropped)="dropTable($event)" 
    [dataSource]="dataSource"
     class="drag-list mat-elevation-z8" >

    <!-- Position Column -->
    <ng-container matColumnDef="dragHandle">
      <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
      <mat-cell *matCellDef="let transformer">
        <mat-icon cursor="grab" cdkDrag cdkDragRootElement=".drag-component" cdkDragHandle   class="drag-icon">reorder</mat-icon>
      </mat-cell>
    </ng-container>
    
    <ng-container matColumnDef="index">
        <mat-header-cell *matHeaderCellDef> Sequence </mat-header-cell>
        <mat-cell *matCellDef="let transformer">{{transformer.index}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let transformer">{{transformer.name}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef> Transform </mat-header-cell>
        <mat-cell *matCellDef="let transformer"> {{transformer.typeDisplayName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="laststatus">
        <mat-header-cell *matHeaderCellDef style="justify-content: flex-start; text-align: left;"> Last Run Status </mat-header-cell>
        <mat-cell *matCellDef="let transformer" [matTooltip]="transformer.transform.run ? transformer.lastRunMessage : ''"
            [ngClass]="{ 'cached': transformer.transform.run && transformer.lastRunStatus==='Completed', 'status-failed': transformer.transform.run && transformer.lastRunStatus==='Failed' }">
            {{ transformer.transform.run ? (transformer.lastRunStatus || 'Not Run') : 'Disabled' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="outputrows">
        <mat-header-cell *matHeaderCellDef style="flex: 0 0 102px; justify-content: flex-end; text-align: right;"> Output Rows </mat-header-cell>
        <mat-cell *matCellDef="let transformer" style="flex: 0 0 102px; justify-content: flex-end; text-align: right;">
            {{ transformer.lastRunOutputRows | number }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="outputcols">
        <mat-header-cell *matHeaderCellDef style="flex: 0 0 90px; justify-content: flex-end; text-align: right;"> Output Cols </mat-header-cell>
        <mat-cell *matCellDef="let transformer" style="flex: 0 0 90px; justify-content: flex-end; text-align: right;">
            {{ transformer.lastRunOutputCols | number }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="runtime">
        <mat-header-cell *matHeaderCellDef style="flex: 0 0 114px; justify-content: flex-end; text-align: right; padding-right: 16px !important;"> Run Time </mat-header-cell>
        <mat-cell *matCellDef="let transformer" style="flex: 0 0 114px; justify-content: flex-end; text-align: right; padding-right: 16px !important;">
            {{ transformer.lastRunTime }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="iscached">
        <mat-header-cell *matHeaderCellDef> Cache State </mat-header-cell>
        <mat-cell *matCellDef="let transformer" [ngClass]="{ 'cached': transformer.transform.run && transformer.isCached==='Cached', 'not-cached': transformer.transform.run && transformer.isCached!=='Cached' }">
            {{ transformer.transform.run ? transformer.isCached : 'N/A' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="runToggle">
        <mat-header-cell *matHeaderCellDef>
            <div style="display: flex; flex-direction: column; align-items: flex-start;width: 40px;">
                <span style="margin-bottom: 2px; text-align:right ">Run?</span>
                <mat-slide-toggle
                    [checked]="allNodeTransformersRunEnabled"
                    (change)="onRunChanged($event)"
                    color="primary" style="text-align: right;">
                </mat-slide-toggle>
            </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let transformer" style="text-align: right;width: 40px;" (click)="$event.stopPropagation()">
            <mat-slide-toggle
                color="primary"
                [(ngModel)]="transformer.transform.run"
                (change)="onTransformerRunToggled(transformer)">
            </mat-slide-toggle>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let transformer">
            <button mat-icon-button (click)="$event.stopPropagation(); deleteTransformer(transformer)">
                <mat-icon class="icon red-icon" title="Delete">delete_forever</mat-icon>
            </button>
        </mat-cell>
    </ng-container>

    <!-- <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
     -->
      <mat-header-row
      *matHeaderRowDef="columnsToDisplay; sticky: true">
    </mat-header-row>
    <mat-row
        class="drag-component"
        style="cursor: pointer;" 
        (click)="showTransformDetail(transform)"
        *matRowDef="let transform; columns: columnsToDisplay;" >
        <!-- [ngClass]="{'hidden': hideshowrow(transform)}" -->
    </mat-row>
    
    <div *cdkDragPlaceholder></div>
        
</mat-table>
</div>

</div>